import { formatMinorAmount, getMinorUnitsSync, formatAmount } from '@sharecost/shared';

interface AmountDisplayProps {
  /** Amount in minor units */
  amountMinor?: number;
  /** Or amount as a decimal number */
  amount?: number;
  /** Currency code */
  currency: string;
  /** Additional CSS classes */
  className?: string;
  /** Show positive amounts in green, negative in red */
  colorize?: boolean;
  /** Hide decimal places */
  hideDecimals?: boolean;
}

export function AmountDisplay({
  amountMinor,
  amount,
  currency,
  className = '',
  colorize = false,
  hideDecimals = false,
}: AmountDisplayProps) {
  let formatted: string;

  if (amountMinor !== undefined) {
    const minorUnits = getMinorUnitsSync(currency);
    formatted = formatMinorAmount(amountMinor, currency, minorUnits, undefined, hideDecimals);
  } else if (amount !== undefined) {
    formatted = formatAmount(amount, currency, undefined, hideDecimals);
  } else {
    formatted = '--';
  }

  let colorClass = '';
  if (colorize) {
    const value = amountMinor ?? amount ?? 0;
    if (value > 0) colorClass = 'text-green-600 dark:text-green-400';
    else if (value < 0) colorClass = 'text-red-600 dark:text-red-400';
  }

  return <span className={`${colorClass} ${className}`}>{formatted}</span>;
}
